import actionTypes from '../constants/actionTypes';
import createFetchingHandlers from '../../../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../../../utils/createListReducer';

const {
  CLOSURE_DATA_FETCH,
  CLOSURE_DATA_SUCCESS,
  CLOSURE_DATA_ERROR,
} = actionTypes;

const initialState = {
  data: [],
  metadata: {},
};

const fetchingData = createFetchingHandlers([CLOSURE_DATA_FETCH, CLOSURE_DATA_SUCCESS, CLOSURE_DATA_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [CLOSURE_DATA_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = { ...action?.payload };
    return { ...outputState };
  },
};

export default createListReducer(
  initialState,
  [fetchingData, getDataHandler],
);
